// extracted by mini-css-extract-plugin
export default {"paymentProvidersTabs":"PaymentProviders_paymentProvidersTabs__y3UB7"};